import { render, staticRenderFns } from "./report_detail.vue?vue&type=template&id=1335aac2&"
import script from "./report_detail.vue?vue&type=script&lang=js&"
export * from "./report_detail.vue?vue&type=script&lang=js&"
import style0 from "./report_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports